























import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import { CrudService } from "@/shared/core/services/crudService";
import { Settings, SettingsService } from "@/shared/core/services/configService";
import { ShopService } from "@/shared/core/services/shopService";
import { LocalStorage } from "@/shared/core/localStorage";
import { CustomerHelper } from "@/shared/crm/helpers/customerHelper";
import CzPage from "@/shared/components/cz/CzPage.vue";
import CzCard from "@/shared/components/cz/CzCard.vue";
import CzGlow from "@/shared/components/cz/CzGlow.vue";
import CzTitle from "@/shared/components/cz/CzTitle.vue";
import CzListRow from "@/shared/components/cz/CzListRow.vue";
import CzButton from "@/shared/components/cz/CzButton.vue";

// "My account" (approved menu, 22-10): everything about the account in one list, with the pending questionnaires.
@Component({ components: { CzPage, CzCard, CzGlow, CzTitle, CzListRow, CzButton } })
export default class MyAccountPage extends Vue {
  surveysPending: number = 0;
  hasReports: boolean = false;

  get customer(): any {
    try {
      return JSON.parse(LocalStorage.getWithTimeout("cc")) || {};
    } catch {
      return {};
    }
  }

  get email(): string {
    return this.customer.email || "";
  }

  get initial(): string {
    return ((this.customer.name || "·").trim().charAt(0) || "·").toUpperCase();
  }

  async mounted() {
    new SettingsService().setPageTitle(this.$t("My account").toString());
    const customer = CustomerHelper.getStoredCustomer();
    const crud = new CrudService();
    const [surveys, reports] = await Promise.all([
      crud.httpGet(`${Settings.HostName}/api/publiccustomersurveys/customer-surveys/${customer}`),
      crud.httpGet(`${Settings.HostName}/api/publicreports/customer/${customer}`),
    ]);
    this.surveysPending = Array.isArray(surveys) ? surveys.filter((s: any) => s.answeredDate === null && s.token).length : 0;
    this.hasReports = reports != null && reports.ok === true && reports.data.length > 0;
  }

  logout() {
    new ShopService().removeCart();
    CustomerHelper.logOut();
    window.location.reload();
  }
}
